<br>
<!--<a mat-button matTooltip="add new account from sample" (click)="openDialogBusinessCommand(EnumIEnterpriseBusinessCommand.USER_CREATE_ACCOUNT_SAMPLE)">-->
<!--    <mat-icon>shop</mat-icon>-->
<!--</a>-->
<div style="position: relative;">
    <mat-tab-group #tabGroup animationDuration="0ms" tabGroupDrag (selectedTabChange)="activeTabIndex = $event.index;" mat-stretch-tabs="false" mat-align-tabs="start">
        <ng-template mat-tab-label>
            <mat-icon class="tab-icon">list</mat-icon>
            {{ 'general.details' | transloco }}
        </ng-template>
        <!--    <mat-tab *ngIf="!enterpriseMode || dashboardMode" label="{{'general.subscription' | transloco}}">-->
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">person</mat-icon>
                {{ 'general.personal' | transloco }}
            </ng-template>
            @if (fintechService.payerId != null) {
                <label class="header-label" style="user-select: text !important;">BusinessId: {{fintechService.businessId}}, PayerId: {{fintechService.payerId}}</label>
                <app-video-link videoLink="accountInfo1" style="position: absolute; right: 20px"></app-video-link>
                <hr>
            }
            @else {
                <div>
                    <app-loading type="6" [style]="{'margin-top': '200px'}"></app-loading>
                </div>
            }


            <app-fintech-recurring-status></app-fintech-recurring-status>
            <app-fintech-contact></app-fintech-contact>
            <hr>
            <app-fintech-paymethod-editor setFintechMode="ACCOUNT"></app-fintech-paymethod-editor>
            <app-fintech-shipping></app-fintech-shipping>
            <app-fintech-payment-info></app-fintech-payment-info>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon class="tab-icon">shopping_bag</mat-icon>
                {{ 'general.orders' | transloco }}
            </ng-template>
            @if (activeTabIndex == 1) {
                <mat-drawer-container>
                    <mat-drawer opened [mode]="sidenavMode" #drawerNav>
                        <div >
                            <app-video-link videoLink="orders"></app-video-link>
                        </div>
                        <div fxFlex="225px" class="navList">



                            @if (orderList) {
                                <app-simple-list #simplelist [list]="orderList" [contentId]="getId()"
                                                 [icon]="'attach_money'" (selected)="onSelection()" [multiSelect]="false"
                                                 [content]="getContent">
                                </app-simple-list>
                            }
                            @if (!ready) {
                                <div style="padding-left: 85px;">
                                    <app-loading [@inOutAnimation] [size]="'50px'" [style]="{'margin-top': '150px'}">
                                    </app-loading>
                                </div>
                            }
                        </div>
                    </mat-drawer>
                    <mat-drawer-content>
                        <div class="content customBackgroundColor navList">
                            @if (!ready) {
                                <app-loading [@inOutAnimation] [size]="'50px'" [style]="{'margin-top': '150px'}">
                                </app-loading>
                            }
                            <app-order-details [order]="order" (toggleMinimize)="drawerNav.toggle();"></app-order-details>
                        </div>
                    </mat-drawer-content>
                </mat-drawer-container>
            }
        </mat-tab>
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">lock</mat-icon>
                    {{ 'general.security' | transloco }}
                </ng-template>
                <div class="tabCredentials">
                    <app-video-link videoLink="security" style="position: absolute; right: 15px;"></app-video-link>
                    @if (!dashboardMode) {
                        <div>
                            <br/>
                            <mat-label>{{ 'account.revealPasswordInfo' | transloco }}</mat-label>
                            <br/>
                            <br/>
                            <button type="submit" (click)="onRevealPassword()" class="sub" mat-stroked-button color="primary">
                                {{ 'account.revealPassword' | transloco }}
                                <mat-icon style="font-size: 1.3em; position: absolute; right: 10px">vpn_key</mat-icon>
                            </button>
                            <br/>
                        </div>
                    }
                    <app-change-password [preFill]="true" [hideBack]="true"></app-change-password>
                    <br/>
                    <br/>
                    <mat-divider></mat-divider>

                    <div *ngIf="!dashboardMode" fxLayout="row" fxLayoutAlign="start start">
                        <app-two-factor [userLoggedIn]="true" [hideBack]="true"></app-two-factor>
                    </div>
                    <br/>
                    <mat-divider></mat-divider>
                    <br/>

                    <div fxLayout="row" fxLayoutAlign="start start">
                        @if (dashboardMode) {
                            <app-reseller-user-name style="padding-right: 100px"></app-reseller-user-name>
                        }
                        <app-forgot-password [userLoggedIn]="true" [hideBack]="true"></app-forgot-password>
                    </div>
                    <br/>
                    <mat-divider></mat-divider>
                    <br/>
                    <mat-radio-group (change)="onChangeAvatar($event)" class="radio-group" [(ngModel)]="useAvatar">
                        <mat-radio-button value="0">{{ 'general.useAvatar' | transloco }}</mat-radio-button>
                        <app-business-rename [loginMode]="false"></app-business-rename>
                        <mat-divider></mat-divider>
                        <br/>
                        <mat-radio-button value="1">{{ 'general.useAvatar' | transloco }}</mat-radio-button>
                        <div fxLayout="row" class="form-element flex-xs-col" style="margin-top: 20px; margin-right: 20px">
                            <div fxFlex="100%" class="actions">
                                <button mat-raised-button color="accent" (click)="updateAvatar()"
                                        [disabled]="!avatarFile || avatarInvalid || uploaded"
                                        [matTooltip]="uploaded ? ('general.avatarUpdated' | transloco) : avatarFile ? ('general.avatarClick' | transloco) : ('general.noFile' | transloco)"
                                        matTooltipPosition="right">
                                    {{ uploaded ? 'Updated' : 'Update' }}
                                </button>
                                <div class="error-wrapper">
                                    <mat-error>
                                        @if (avatarTooSmall) {
                                            {{ 'general.tooLarge' | transloco }}
                                        }
                                        @if (avatarTooLarge) {
                                            {{ 'general.tooSmall' | transloco }}
                                        }
                                    </mat-error>
                                </div>
                            </div>
                            <img class="avatar" [src]="avatarSrc || user.avatarURL" style="width: 120px;">
                        </div>
                    </mat-radio-group>
                </div>
            </mat-tab>
<!--
            @if (devMode) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">poll</mat-icon>
                        {{ 'general.statistics' | transloco }}
                    </ng-template>
                </mat-tab>
            }
-->
        }
    </mat-tab-group>
</div>


<ng-template let-modal #revealPassword class="transparentDialog">
    <div mat-dialog-content>
        <br/>
        <br/>
        <br/>
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-label>{{ 'account.revealPasswordInfo' | transloco }}</mat-label>
            <div style="margin: 15px;">
                @if (!mouseDown) {
                    <mat-label class="revealWidth">****************</mat-label>
                }
                @if (mouseDown) {
                    <mat-label class="revealWidth">{{ user.passwordNew }}</mat-label>
                }
                <br/>
                <br/>
                <br/>
                <button (mousedown)="mouseDown =true" (mouseup)="mouseDown=false" color="warn" mat-raised-button style="margin-right: 10px; width: 250px">
                    <mat-icon>key</mat-icon>
                </button>
            </div>
        </div>
        <br/>
        <br/>
    </div>
</ng-template>
